import {customElement, property, query, state} from "lit/decorators";
import {css, html, LitElement, nothing} from "lit";
import {col, grow, hide, margin, padding, paddingAll, row} from "../styles";

import Debug from "debug";
import pdqHotkeyService from "../services/PdqHotkeyService";
import ViewOff16 from '@carbon/web-components/es/icons/view--off/16.js';
import View16 from '@carbon/web-components/es/icons/view/16.js';

import '@carbon/web-components/es/components/tag/index.js';
const log = Debug('pdq:flow:pdq-view');

@customElement('pdq-toolbar')
export class PdqToolbar extends LitElement {
    static styles = [hide, row, col, grow, padding, margin]
    icon = View16;

    constructor() {
        super();
        pdqHotkeyService.showPdqData.subscribe((show: boolean) => {
            this.icon = show ? ViewOff16 : View16;
            this.requestUpdate()
        })
    }

    render() {
        return html`
          <slot>
            <cds-button @click="${pdqHotkeyService.toggleView()}">
              ${this.icon({slot: 'icon'})}
            </cds-button>
          </slot>
        `
    }
}
